import { render, staticRenderFns } from "./StudentInfoSelector.vue?vue&type=template&id=257b3e90&"
import script from "./StudentInfoSelector.vue?vue&type=script&lang=js&"
export * from "./StudentInfoSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports